module.exports = __webpack_public_path__ + "static/abcism-logo-e98e7b9cf9adcd1fe0cdcc14c2156a59.gif";